const appName = 'SchoolRollHost';
export const teacherUserTypeId = 2;
export default appName;

export const DEFAULT_COURSE_ID = 0;

export const ROLLOVER_INFO_MODAL_OPTOUT = 'ROLLOVER_INFO_MODAL_OPTOUT';

export const DEFAULT_UPF_COURSE_ID = '0';
export const DEFAULT_LEGACY_COURSE_ID = '-1';
export const DEFAULT_NEW_COURSE_ID = '00000000-0000-0000-0000-000000000000';

export const DEFAULT_COUNTRY_ID = '-1';
export const DEFAULT_YEAR_GROUP = '-1';
export const DEFAULT_TEACHER_ID = '-1';

export const DROPDOWN_OPTION_LENGTH = 60;

export const AUSTRALIA_REGION_ID = 8;



// WEBPACK FOOTER //
// ./app/constants.js